import { isGoogleSignupSupported } from '../google-authentication/utils/isGoogleSignupSupported';
import { SignupApiFlowPath } from '../http-clients/SignupApiFlowPath';
import { ViaParam } from '../intents/ViaParam';
import { isMicrosoftOAuthEnabled } from '../microsoft/utils/isMicrosoftOAuthEnabled';
import { OAuthProviders } from '../oauth/OAuthProviders';
import { getScoreSalesProducts } from '../utils/scorePortal';
export const DefaultFlowOptions = {
  showMobileAppPrompt: false,
  shouldAddHubInterestStep: () => false,
  shouldSkipExistingAccountStep: false,
  isOptionalDomainEnabled: false,
  shouldShowBoxAccountCard: false,
  shouldShowTitleOnExistingUserView: false,
  shouldShowSignInButton: true,
  shouldHalveProgressBar: false,
  shouldPreFillCompanyName: true,
  oAuthsEnabled: {
    [OAuthProviders.Google]: isGoogleSignupSupported(),
    [OAuthProviders.Microsoft]: isMicrosoftOAuthEnabled()
  },
  signupApiFlowPath: SignupApiFlowPath.Crm,
  viaParam: ViaParam.CrmSignup,
  shouldRedirectExistingUserAutomatically: true,
  scoringFunction: getScoreSalesProducts,
  createAccountTextI18nLabel: 'legal.createAccountTermsOfService',
  shouldSkipExistingAccountStepIfOneAccount: false
};
export const HSFXFlowOptions = Object.assign({}, DefaultFlowOptions, {
  shouldHalveProgressBar: true
});
export const FlowOptionsWithMobileAppPrompt = Object.assign({}, DefaultFlowOptions, {
  showMobileAppPrompt: true
});
export const DevelopersFlowOptions = Object.assign({}, DefaultFlowOptions, {
  shouldPreFillCompanyName: false
});